import { useContext, useState } from 'react';
import AuthContext from '../../../contexts/AuthContext';
import WalletContext from '../../../contexts/WalletContext';
import { formatCurrency } from '../../../utility/number.utils';
import AddCashModal from '../../dialogs/add-cash-dialog';
import RequestCashOutModal from '../../dialogs/request-cash-out-dialog';
import Skeletone from '../../ui/Skeletone';
import WalletInfoCard from '../walletInfoCard';
import styles from './style.module.scss';

const WalletInformation = () => {
  const [addCashModal, setAddCashModal] = useState(false);
  const [cashOutModal, setCashOutModal] = useState(false);
  const { userRole } = useContext(AuthContext);

  const { walletData, refetch, isLoading } = useContext(WalletContext);
  return (
    <>
      <AddCashModal
        open={addCashModal}
        onClose={() => setAddCashModal(false)}
      />
      <RequestCashOutModal
        open={cashOutModal}
        onClose={() => setCashOutModal(false)}
        refetch={refetch}
      />
      <div className={styles.wrapper}>
        <div className={styles.inner}>
          {isLoading ? (
            <Skeletone variant="light" />
          ) : (
            <>
              <WalletInfoCard
                loading={isLoading}
                amount={formatCurrency(walletData?.Balance ?? 0, {
                  currency: '',
                  decimals: 0,
                })}
                title="Wallet Balance"
                // buttonText="Add Cash"
                lastTransaction={`${
                  walletData?.LastTransaction
                    ? formatCurrency(walletData?.LastTransaction, {
                        currency: '',
                        decimals: 0,
                      })
                    : 'No Transactions Yet'
                }`}
                lastTransactionText="Last Transaction"
                // onButtonClick={() => setAddCashModal(true)}
                // className="w-100"
              />
              <div className={styles.separator}></div>
            </>
          )}

          {/* <WalletInfoCard
            // className="w-100"
            amount="686.12"
            title="Cashback Wallet"
            lastTransaction="150"
            hideIcon
            lastTransactionText="Last Cashback"
          /> */}
        </div>
        {isLoading ? (
          <Skeletone variant="light" className="w-100 bg-white" />
        ) : (
          userRole === 'VENDOR' && (
            <WalletInfoCard
              // className="w-100"
              loading={isLoading}
              amount={`
              ${
                walletData?.totalCashoutAmount
                  ? formatCurrency(walletData?.totalCashoutAmount, {
                      currency: '',
                      decimals: 0,
                    })
                  : 0
              }
            `}
              title="Total Cashout"
              buttonText="Request Cash Out "
              lastTransaction={`${walletData?.LastCashout || 0}`}
              lastTransactionText="Last Cashed out"
              onButtonClick={() => setCashOutModal(true)}
            />
          )
        )}
      </div>
    </>
  );
};

export default WalletInformation;
